export const situationMap = {
  ALL_ORDERS: { color: '#d1d5db', text: 'ALL', keys: ['Todas as Ordens'] },
  PAID_OFF: { color: '#dcfce7', text: 'PAID_OFF', keys: ['Quitado', '50130005'] },
  SOLVED: { color: '#dcfce7', text: 'SOLVED', keys: ['50060004'] },
  OPEN_SUPPORT_CALL: { color: '#dbeafe', text: 'OPEN_SUPPORT_CALL', keys: ['50060001'] },
  FINISHED: { color: '#dcfce7', text: 'FINISHED', keys: ['50060005'] },
  PROCESSING: { color: '#e9d5ff', text: 'PROCESSING', keys: ['50060002'] },
  ACTIVE: { color: '#dcfce7', text: 'ACTIVE', keys: ['A'] },
  PENDING: { color: '#dbeafe', text: 'PENDING', keys: ['Em Aberto', 'Regular', '50130001'] },
  EXEMPT: { color: '#fef9c3', text: 'EXEMPT', keys: ['Isento', '50130004'] },
  OVERDUE: { color: '#fecaca', text: 'OVERDUE', keys: ['Vencida'] },
  CANCELED: { color: '#fecaca', text: 'CANCELED', keys: ['C', '50060003'] },
  NEGOTIATED: { color: '#e9d5ff', text: 'NEGOTIATED', keys: ['Negociada', '50130007'] },
  DUPLICATED: { color: '#dfa9ce', text: 'DUPLICATED', keys: ['50130006'] }
}
